import { Box, Container, Typography } from "@mui/material";
import React from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const faqs = [
  {
    id: "1",
    question: "How to contact with riders emergency?",
    answer:
      "Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home.",
  },
  {
    id: "2",
    question: "App installation failed, how to update system information?",
    answer:
      "Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home.",
  },
  {
    id: "3",
    question: "Website reponse taking time, how to improve?",
    answer:
      "Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home.",
  },
  {
    id: "4",
    question: "New update fixed all bug and issues",
    answer:
      "Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home collect a sample from management news. Get your blood tests delivered at the home.",
  },
];

const FAQ = () => {
  return (
    <div>
      <Container sx={{ py: 6 }}>
        <Box sx={{ textAlign: "center" }}>
          <Typography className="sub-title" variant="subtitle1">
            Frequent Question
          </Typography>
          <Typography className="section-title" variant="h3">
            Do you have any question
          </Typography>
        </Box>
        {/* faqs  */}
        <Box sx={{ mt: 4 }}>
          {faqs.map((faq) => (
            <Accordion
              key={faq.id}
              sx={{
                my: 2,
                borderRadius: "20px",
                boxShadow: 0,
              }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon color="secondary" />}
              >
                <Typography
                  sx={{ fontSize: { xs: 16, md: 18 }, fontWeight: 500 }}
                >
                  {faq.question}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ fontSize: 16 }} variant="body1">
                  {faq.answer}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Box>
      </Container>
    </div>
  );
};

export default FAQ;
